import React from 'react';
import {SvgIcon} from '@fiverr/fit';
import PropTypes from 'prop-types';
import shortid from 'shortid';
import './style.scss';

const VOTES_THRESHOLD = 1000;
const LIMITED_RATINGS_THRESHOLD = 100;
const FULL_STAR = 'full_star';
const EMPTY_STAR = 'o_star';
const HALF_STAR = 'o_half_star';

const Rating = ({ score, votes, starSize, starCount, isPro, risingTalentExpVariation, limitDisplayedRatings }) => {

    const getVotes = () => {
        if (risingTalentExpVariation) {
            return i18n.t('gigs.general.editors_choice');
        } else if (limitDisplayedRatings && votes >= LIMITED_RATINGS_THRESHOLD) {
            return `${LIMITED_RATINGS_THRESHOLD}+`;
        } else if (votes >= VOTES_THRESHOLD) {
            return `${Math.round(votes / VOTES_THRESHOLD)}k+`;
        }

        return votes;
    };

    const scoreText = risingTalentExpVariation ? (5).toFixed(1) : (score / 2).toFixed(1),
        votesText = `(${getVotes()})`,
        starsScoreNum = Math.round(parseFloat(scoreText) * 2) / 2,
        starAttrs = {
            icon: FULL_STAR,
            color: 'yellow',
            width: starSize,
            height: starSize
        },
        stars = [],
        isNonRatedProSeller = score <= 0 && isPro,
        showScore = score > 0 || risingTalentExpVariation;

    for (let star = 1; star <= starCount; star++) {
        if (starCount > 1) {
            if (star <= starsScoreNum) {
                starAttrs.icon = FULL_STAR;
            } else if (star > Math.round(starsScoreNum)) {
                starAttrs.icon = EMPTY_STAR;
            } else {
                starAttrs.icon = HALF_STAR;
            }
        }

        starAttrs.key = shortid.generate();

        stars.push(<SvgIcon {...starAttrs}/>);
    }

    return (
        <span className="gig-rating">
            {stars}
            {isNonRatedProSeller && <strong>{i18n.t('general.be_the_first_to_rate')}</strong>}
            {showScore && <span><strong>{scoreText}</strong> {votesText}</span>}
        </span>
    );
};

Rating.propTypes = {
    score: PropTypes.number,
    votes: PropTypes.number
};

export default Rating;



// WEBPACK FOOTER //
// ./src/shared/rating/index.js